export default __webpack_public_path__ + "static/media/document-attach-outline.0bea7eba.svg";